"use client";

import { faGlobe } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Image } from "antd";
import { FC, useEffect, useState } from "react";

type EsimPackageCoverProps = {
  imageUrl?: string;
  height: number;
  className?: string;
  alt?: string;
  /** Placeholder đẹp hơn khi chưa có ảnh — gradient + icon globe, cùng ngôn ngữ thiết kế với
   * `EsimDestinationCard` (trang chủ eSIM), thay vì ô xám trơn mặc định. Chỉ bật ở nơi cần nổi bật
   * rõ (vd "Bạn có thể quan tâm") — mặc định `false` để không đổi giao diện các nơi khác đang dùng
   * component này (catalog/search/group detail/...). */
  fancyPlaceholder?: boolean;
};

export const isValidEsimImageUrl = (url?: string): url is string => {
  const trimmed = url?.trim();
  if (!trimmed) return false;
  if (trimmed.startsWith("/")) return true;
  try {
    const parsed = new URL(trimmed);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
};

const EsimPackageCover: FC<EsimPackageCoverProps> = ({
  imageUrl,
  height,
  className,
  alt,
  fancyPlaceholder,
}) => {
  const validUrl = isValidEsimImageUrl(imageUrl) ? imageUrl.trim() : undefined;
  const [loadFailed, setLoadFailed] = useState(false);

  useEffect(() => {
    setLoadFailed(false);
  }, [validUrl]);

  if (!validUrl || loadFailed) {
    return (
      <div
        className={[
          "esim-package-cover",
          "esim-package-cover--placeholder",
          fancyPlaceholder && "esim-package-cover--placeholder-fancy",
          className,
        ]
          .filter(Boolean)
          .join(" ")}
        style={{ height }}
        aria-hidden
      >
        {fancyPlaceholder && (
          <FontAwesomeIcon icon={faGlobe} className="esim-package-cover__placeholder-icon" />
        )}
      </div>
    );
  }

  return (
    <Image
      alt={alt || "Gói eSIM du lịch"}
      src={validUrl}
      preview={false}
      height={height}
      className={["esim-package-cover", className].filter(Boolean).join(" ")}
      style={{ objectFit: "cover" }}
      onError={() => setLoadFailed(true)}
    />
  );
};

export default EsimPackageCover;
